export interface WebSocketResponse<T> {
  identifier: string;
  message: WebSocketMessage<T>;
}

export interface WebSocketMessage<T> {
  action: WebSocketActionTypeEnum;
  object: {
    data: T;
  };
}
export interface WebSocketParsed<T> {
  action: WebSocketActionTypeEnum;
  data: T;
}

export enum WebSocketActionTypeEnum {
  update = 'update',
  delete = 'delete',
  create = 'create',
}
